import { getUserEntity, getUserFunctionalities } from 'common/UserEntityProvider';

export type IEditingModeSetings = {
  edit: boolean,
  view: boolean,
  delete: boolean, 
  editByOwner: boolean,
  viewByOwner: boolean,
  deleteByOwner: boolean
};

export const hasPermission = ({ scopes }) => {

  const scopesMap = {};
  scopes?.forEach((scope) => {
    scopesMap[scope] = true;
  });

  const permissions = getUserEntity()?.scopes.map(x => x.scope);


  return permissions?.some(
    (permission) => scopesMap[permission]
  );
}

export const hasRole = ({ userRoles, roles }) => {
  const rolesMap = {};
  roles?.forEach((role) => {
    rolesMap[role] = true;
  });

  return userRoles?.some((role) => rolesMap[role]);
};

// Check if the user is the owner of the entity and enable changes
export const isEditableByOwner = (entityType:number, entityId:number, wfEditSettings: IEditingModeSetings ): boolean => {
    return (getUserEntity().entityType == entityType && getUserEntity().entityId == entityId && wfEditSettings?.editByOwner);
}

// Returns true if the user has access to a UI functionality identifier.
// accessType null or absent = full access granted; 1 = view only; 2 = edit.
// requiredAccess: null/undefined = any access (view or full), 'edit' = requires full or edit access.
export const hasFunctionality = (identifier: string, requiredAccess?: 'view' | 'edit'): boolean => {
  const functionalities = getUserFunctionalities();
  const match = functionalities?.find(f => f.identifier === identifier);
  if (!match) return false;
  if (requiredAccess === 'edit') {
    // accessType null = full, 2 = edit — both satisfy edit requirement
    return match.accessType == null || match.accessType === 2;
  }
  // any access (view or full) satisfies view requirement
  return true;
}
